import { FieldHookConfig, useField, useFormikContext } from 'formik';
import { useEffect } from 'react';
import CustomField from './CustomField';
import { useTranslation } from 'react-i18next';

export default function TemplateDurationField(props: FieldHookConfig<number>) {
  const {
    values: { moduleIds },
    setFieldValue,
  } = useFormikContext<any>();
  const [t] = useTranslation('admin');
  const [field] = useField(props);

  useEffect(() => {
    setFieldValue(props.name, moduleIds.length);
  }, [moduleIds, props.name, setFieldValue]);

  return (
    <CustomField
      title={t('activity_duration', '活動天數')}
      placeholder={t('activity_duration_placeholder', '請輸入活動天數')}
      name={props.name}
    >
      <input
        className="h-10 w-full border border-[#53586C] rounded py-3 px-4 placeholder:text-gray-700/70 mt-3 disabled:bg-gray-100"
        type="number"
        min={0}
        max={10}
        disabled={true}
        {...field}
      />
    </CustomField>
  );
}
